import * as Joi from "joi";
import moment from "moment";


const email = Joi.object().keys({
  email: Joi.string().required().pattern(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_-]+)\.([a-zA-Z.]{2,22})$/)
})

const phone = Joi.object().keys({
  type: Joi.string().required(),
  phone_number: Joi.string().required(),
})

const contact = Joi.object().keys({
  name: Joi.object().keys({
    "title": Joi.string().required(),
    "firstname": Joi.string().required().max(40),
    "lastname": Joi.string().required().max(80),
    "middlename": Joi.string().optional().max(80)
  }),
  date_of_birth: Joi.custom((value, helper) => {
    var years = moment().diff(value, "years", false);
    if (years < 50) {
      return helper.message("{{#label}} Age must be more then 18 years ")
    } else {
      return true
    }
  }),
  gender: Joi.string().required(),
  emails: Joi.array().min(1).required().items(email),
  phone: Joi.array().min(1).required().items(phone).custom((value, helper) => {
    let hasMobile = false;
    value.forEach(element => {
      if (element.type == "Mobile" && element.phone_number.length <= 10) {
        hasMobile = true;
      }
    });
    if (!hasMobile) {
      return helper.message("{{#label}} mobile number is required ")
    }

    return hasMobile;
  })
})

const identifications = Joi.object().keys({
  id_number: Joi.string().required(),
  type: Joi.string().required(),
  expiry_date: Joi.custom((value, helper) => {
    var expiredAt = moment().diff(value, "days", false);
    if (expiredAt > 1) {
      return helper.message("{{#label}} is expired")
    } else {
      return true
    }
  }),
  state_of_issue: Joi.string().valid("ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA")
})
const personalDetails = Joi.object().keys({
  identifications: Joi.array().min(1).required().items(identifications).custom((value, helper) => {
    let hasLicense = false;
    value.forEach(element => {
      if (element.type == "License") {
        hasLicense = true;
      }
    });
    if (!hasLicense) {
      return helper.message("{{#label}} license is required ")
    }

    return hasLicense;
  })
})

const address = Joi.object().keys({
  ownership: Joi.string().required(),
  address: Joi.object().keys({
    street_number: Joi.string().max(8).required(),
    suburb: Joi.string().max(40).required(),
    state: Joi.string().min(2).max(3).required(),
    post_code: Joi.string().pattern(/^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/)
  }),
  duration: Joi.object().keys({
    years: Joi.number().min(0).max(100).required(),
    months: Joi.number().min(0).max(11).required()
  }),
  landlord: Joi.when('ownership', {
    is: "Rented",
    then: Joi.object().keys({
      name: Joi.string().max(100).required(),
      number: Joi.string().pattern(/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/).required()
    })
  })
})

const employment = Joi.object().keys({
  type: Joi.string().required(),
  employer_details: Joi.object().keys({
    name: Joi.string().required().max(100),
    contact_name: Joi.string().required().max(100),
    contact_number: Joi.string().required().max(10)
  }),
  title: Joi.string().required().max(22),
  duration: Joi.object().keys({
    years: Joi.number().min(0).max(100).required(),
    months: Joi.number().min(0).max(11).required()
  }),
  income: Joi.object().keys({
    amount: Joi.number().min(1).required(),
    frequency: Joi.string().required()
  }),
})


const addresses = Joi.object().keys({
  current: address,
  previous: Joi.array().items(address)
})

const employments = Joi.object().keys({
  current: Joi.array().items(employment),
  previous: Joi.array().items(employment)
})


const reference = Joi.object().keys({
  relationship: Joi.string().required().max(100),
  name: Joi.string().required().max(100),
  phone: Joi.string().required().max(100),
})

const references = Joi.array().items(reference).custom((value, helper) => {
  const hasEmergencyContact = value.filter(el => { return el.is_emergency_contact });
  if (!hasEmergencyContact.length) {
    return helper.message("{{#label}} Emergency contact required ")
  }
})


const applicant = Joi.object().keys({
  contact: contact,
  personal_details: personalDetails,
  addresses: addresses,
  employments: employments,
  references: references
})

const current = Joi.object().keys({
  term: Joi.number().required().min(36).max(60),
  naf: Joi.number().required().min(5001).max(45000),
})

const submission = Joi.object().keys({
  current: current
})

const vehicle = Joi.object().keys({
  value: Joi.number().required().min(1),
  purchase_cost: Joi.number().required().min(1),
})

const asset = Joi.object().keys({
  type: Joi.string().required().valid("Vehicle"),
  vehicle: vehicle
})

const loan = Joi.object().keys({
  submission: submission,
  asset: asset
})

const schema = {
  application: Joi.object().keys({
    applicants: Joi.array().min(1).required().items(applicant),
    loan: loan
  })
}
export {
  schema
};
